import _axios from '../../apiClient'
export function getModalidad() {
  return _axios
    .get('/ConfigGlobal/GetModalidad')
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.error('Error al obtener la modalidad:', error)
      throw error
    })
}
